import { QueryClient } from '@tanstack/react-query';

/**
 * Глобальный QueryClient.
 * Дефолты подобраны под продукт где много клиентов и много ассистентов:
 * - staleTime 30s — кэш свежий полминуты, не дёргаем бэк на каждое перерендеривание
 * - gcTime 5min — даже после ухода со страницы кэш живёт 5 минут (быстрые возвраты)
 * - retry 1 — одна повторная попытка при ошибке (защита от мерцающих сбоев)
 * - refetchOnWindowFocus true — при возврате во вкладку обновляем
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
